import { render, staticRenderFns } from "./FieldPreviewQuestionHistory.vue?vue&type=template&id=1744dd8c&scoped=true"
import script from "./FieldPreviewQuestionHistory.vue?vue&type=script&lang=js"
export * from "./FieldPreviewQuestionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1744dd8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1744dd8c')) {
      api.createRecord('1744dd8c', component.options)
    } else {
      api.reload('1744dd8c', component.options)
    }
    module.hot.accept("./FieldPreviewQuestionHistory.vue?vue&type=template&id=1744dd8c&scoped=true", function () {
      api.rerender('1744dd8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldPreviewQuestionHistory.vue"
export default component.exports